import { appQueryClient } from '~/adapters/reactQuery';
import { surveyQueries } from '../queries/survey.queries';

export const surveyKeys = {
  fetchBasicSurveyList: ({ companyId }) => ['fetchBasicSurveyList', { companyId }],
};

export const fetchBasicSurveyListQuery = (companyId: number) => {
  return appQueryClient.fetchQuery({
    queryKey: surveyKeys.fetchBasicSurveyList({ companyId }),
    queryFn: () => surveyQueries.fetchBasicSurveyList(companyId),
  });
};
